module.exports = function(app) {

    app.controller("pages.spending.spendingSummary", ["$scope", "session","services", "$rootScope","storage","coremetrics","sessionData","spendingAccountsService","$q","spendingResourceServices","$cookies","$timeout","spaUtil","$window",
        function( $scope, session,services, $rootScope, storage,coremetrics,sessionData,spendingAccountsService,$q,spendingResourceServices,$cookies ,$timeout,spaUtil, $window){

            $scope.ebill = function() {
                $window.location = '/member/ebill';
            };

            $scope.submitClaims = function() {
                sessionStorage.incomingUrl = "claim";
                $window.location = '/member/spending/clientListSelection';
            };

            $scope.costTools = function() {
                $window.location = '/member/spending/groupSelection';
            };

        }])

};